module.exports = __webpack_public_path__ + "img/phone.3c25f4d4.svg";